import { __assign } from './_virtual/_tslib.js';

/**
 * 通过defineProperty对赋值操作进行监听
 */
var awaitPreloadAPIResult = function () {
    return new Promise(function (resolve) {
        var preloadApiResult = window.preload_api_result;
        if (preloadApiResult) {
            return resolve(preloadApiResult);
        }
        // 客户端赋值时 自动触发
        Object.defineProperty(window, 'preload_api_result', {
            get: function () {
                return preloadApiResult;
            },
            set: function (value) {
                preloadApiResult = value;
                resolve(value);
            },
            enumerable: true,
            configurable: true,
        });
    });
};
/**
 * 获取基于客户端请求的接口的返回数据
 *
 * @param config 预请求配置
 * @returns
 */
var clientAPIPrefetch = function (config) {
    var prefetchConfig = __assign({ timeout: 1000 * 5 }, config);
    return new Promise(function (resolve, reject) {
        var isTimeout = false;
        var timeoutId;
        var handle = function (data, isError) {
            if (isError === void 0) { isError = false; }
            if (isTimeout) {
                return;
            }
            clearTimeout(timeoutId);
            if (isError) {
                reject(data);
            }
            else {
                resolve(data);
            }
        };
        // 设置超时
        timeoutId = setTimeout(function () {
            handle({
                result: -999,
                message: 'Request timeout',
            }, true);
            isTimeout = true;
        }, prefetchConfig.timeout);
        awaitPreloadAPIResult().then(function (data) {
            // 客户端未发起请求后 传参存在问题 兜底处理
            if (!data || JSON.stringify(data) === '{}') {
                handle({
                    result: -1000,
                    message: 'Client Request Error',
                }, true);
                return;
            }
            handle(data);
        });
    });
};

export { clientAPIPrefetch };
//# sourceMappingURL=client-prefetch.js.map
